module.exports = __webpack_public_path__ + "static/img/edu-lauton-TyQ-0lPp6e4-unsplash_thumb.5171c5d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/edu-lauton-TyQ-0lPp6e4-unsplash_thumb.png
// module id = Is8E
// module chunks = 4